export const formatDate = function (time, step, format) {
  // time时间戳 或 yyyy-MM-dd字符串
  if (typeof time === "string") {
    return time ? new Date(time.replace(/-/g, "/")) : new Date();
  } else if (typeof time === "object") {
    return formatDate(time.getTime(), step, format);
  }
  time = time || new Date().getTime();
  step = step || 0;
  format = format || "yyyy-MM-dd";
  time = time + step * 24 * 60 * 60 * 1000;
  var date = new Date(time);
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();
  month = month < 10 ? "0" + month : month;
  day = day < 10 ? "0" + day : day;
  if (format === "yyyy-MM-dd hh:mm:ss") {
    var hour = date.getHours();
    var minute = date.getMinutes();
    var second = date.getSeconds();
    hour = hour < 10 ? "0" + hour : hour;
    minute = minute < 10 ? "0" + minute : minute;
    second = second < 10 ? "0" + second : second;
    return (
      year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second
    );
  } else if (format === "yyyy-MM-dd HH:mm") {
    var hour = date.getHours();
    var minute = date.getMinutes();
    var second = date.getSeconds();
    hour = hour < 10 ? "0" + hour : hour;
    minute = minute < 10 ? "0" + minute : minute;
    return (
      year + "-" + month + "-" + day + " " + hour + ":" + minute
    );
  } else {
    return year + "-" + month + "-" + day;
  }
};
